import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  teacher: SduiTypes.teacher
): OutTypes.teacher => {
  return {
    ids:         teacher.id,
    displayName: teacher.shortcut,
    person:      {
      lastName:  teacher.firstname,
      firstName: teacher.lastname
    }
  };
};
